import React from 'react';
import ReactDOM from 'react-dom';
import { PDPBuyBox } from './app';
import { PDPInformation } from './components';
const pdpInformation = document.getElementById('pdp-information-section');
if (pdpInformation) {
    try {
        ReactDOM.render(React.createElement(PDPInformation, null), pdpInformation);
    }
    catch (err) {
        console.error(err);
    }
}
const buyBoxContainer = document.getElementById('buyBoxContainer');
try {
    if (buyBoxContainer) {
        const tags = JSON.parse(buyBoxContainer.getAttribute('data-tags'));
        const initialVariant = JSON.parse(buyBoxContainer.getAttribute('data-initial-variant'));
        const initialVariantSubscription = JSON.parse(buyBoxContainer.getAttribute('data-initial-variant-subscription'));
        const subscription = JSON.parse(buyBoxContainer.getAttribute('data-metafields-subscription'));
        const shouldRedirectToLocator = buyBoxContainer.dataset.productShouldRedirectToLocator === 'true';
        const product = JSON.parse(buyBoxContainer.getAttribute('data-product'));
        const productData = {
            initialVariant,
            initialVariantSubscription,
            subscription,
            product,
            tags,
            shouldRedirectToLocator,
        };
        if (buyBoxContainer) {
            ReactDOM.render(React.createElement(PDPBuyBox, Object.assign({}, productData)), buyBoxContainer);
        }
    }
}
catch (error) {
    console.error(error);
}
